import App from "@/views/App.vue";

export default [
  {
    path: "/buscar",
    name: "search",
    component: App,
    redirect: { name: "searchHome" },
    children: [
      {
        path: "",
        name: "searchHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Search.vue"),
        meta: {
          displayName: "displayName.search",
          requiresAuth: true,
        },
      },
      {
        path: "buscar/interesse/:id",
        name: "searchTagId",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/SearchByTag.vue"),
        meta: {
          displayName: "displayName.searchByTag",
          requiresAuth: true,
        },
      },
    ],
  },
];
